import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { SocialProofReviews } from './components/SocialProofReviews';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { LaunchCountdown } from './components/LaunchCountdown';
import { Testimonials } from './components/Testimonials';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Faq } from './components/Faq';
import { CostOfDelay } from './components/CostOfDelay';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { VerifiedPurchasePopup } from './components/VerifiedPurchasePopup';
export function App() {
  return <div className="w-full min-h-full bg-ink-950 text-gray-200" data-id="element-0" data-mp="23t8ea5wf0398">
      <main data-id="element-1" data-mp="3ij668fcdfvai">
        <Hero data-id="element-2" data-mp="3ijpbowku4r7n" />
        <StatsBar data-id="element-3" data-mp="3ihv1ac76whht" />
        <SocialProofReviews data-id="element-4" data-mp="3mlj6wpc9h30f" />
        <ProblemSection data-id="element-5" data-mp="3mkrgru1fnxhj" />
        <SolutionSection data-id="element-6" data-mp="3mjztr7lwj82v" />
        <BonusSection data-id="element-7" data-mp="3mj6jvxrnc2gi" />
        <LaunchCountdown data-id="element-8" data-mp="3rcj2nr9n9f1c" />
        <Testimonials data-id="element-9" data-mp="3rdarmj8qkein" />
        <PricingSection data-id="element-10" data-mp="3rd1all5o5hp3" />
        <ComparisonTable data-id="element-11" data-mp="3relwkmdx3sbc" />
        <GuaranteeSection data-id="element-12" data-mp="6hpnd64cbd2" />
        <Faq data-id="element-13" data-mp="4n6o4eeqtbm" />
        <CostOfDelay data-id="element-14" data-mp="56mnfkhz7n0" />
        <FinalCta data-id="element-15" data-mp="7stfczkdj46" />
      </main>
      <Footer data-id="element-16" data-mp="2zllijblcf2rh" />
      <VerifiedPurchasePopup data-id="element-17" data-mp="2zm4xcjfp5b1a" />
    </div>;
}